import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'nb',
  months: [
    'januar',
    'februar',
    'mars',
    'april',
    'mai',
    'juni',
    'juli',
    'august',
    'september',
    'oktober',
    'november',
    'desember',
  ],
  monthsShort: ['jan', 'feb', 'mar', 'apr', 'mai', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'des'],
  weekdays: ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'],
  weekdaysMin: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
  weekdaysShort: ['søn.', 'man.', 'tir.', 'ons.', 'tor.', 'fre.', 'lør.'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: 'DD.MM.YYYY',
    LL: 'D. MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D. MMMM',
    LLL: 'D. MMMM YYYY HH:mm',
    'LLL-Y': 'D. MMMM HH:mm',
    LLLL: 'dddd D. MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd D. MMMM HH:mm',
    l: 'DD.MM.YYYY',
    'l-Y': 'DD.MM',
    ll: 'D. MMM YYYY',
    'll-Y': 'D. MMM',
    lll: 'D. MMM YYYY HH:mm',
    'lll-Y': 'D. MMM HH:mm',
    llll: 'ddd D. MMM YYYY HH:mm',
    'llll-Y': 'ddd D. MMM HH:mm',
    'll-Y+w': 'ddd D. MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D. MMMM YYYY, HH:mm ([GMT]Z)',
  },
  past: {
    y: { one: 'for %s år siden', other: 'for %s år siden' },
    M: { one: 'for %s md. siden', other: 'for %s md. siden' },
    w: { one: 'for %s u. siden', other: 'for %s u. siden' },
    d: { one: 'for %s d. siden', other: 'for %s d. siden' },
    h: { one: 'for %s t siden', other: 'for %s t siden' },
    m: { one: 'for %s min siden', other: 'for %s min siden' },
    s: { one: 'for %s sek siden', other: 'for %s sek siden' },
  },
  future: {
    y: { one: 'om %s år', other: 'om %s år' },
    M: { one: 'om %s md.', other: 'om %s md.' },
    w: { one: 'om %s u.', other: 'om %s u.' },
    d: { one: 'om %s d.', other: 'om %s d.' },
    h: { one: 'om %s t', other: 'om %s t' },
    m: { one: 'om %s min', other: 'om %s min' },
    s: { one: 'om %s sek', other: 'om %s sek' },
  },
  abbr: {
    y: { one: '%s år', other: '%s år' },
    M: { one: '%s md.', other: '%s md.' },
    w: { one: '%s uke', other: '%s uker' },
    d: { one: '%s d', other: '%s d' },
    h: { one: '%s t', other: '%s t' },
    m: { one: '%s min', other: '%s min' },
    s: { one: '%s sek', other: '%s sek' },
  },
  justNow: 'Akkurat nå',
  yesterday: 'I går',
  today: 'I dag',
  tomorrow: 'I morgen',
  weekStart: 1,
};
const localeName: LocaleName = 'nb';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (): string => '',
};
